<template>
  <div class="relative mt-16 mb-16 p-4 max-w-screen-sm mx-auto">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PageContainer',
}
</script>